requirejs.config({
    baseUrl: '/dist/js', // dev: '/src' live: '/dist/js'
	deps: ['common'],
	waitSeconds: 120,
	paths: {
		fancybox: 'libs/fancybox/jquery.fancybox',
		fastclick: 'libs/fastclick/fastclick',
		gmap3: 'libs/gmap3/gmap3.min',
		history: 'libs/history.js/scripts/bundled/html4+html5/native.history',
		jquery: 'libs/jquery/jquery',
		jqueryForm: 'libs/jquery-form/jquery.form',
		jqueryValidation: 'libs/jquery-validation/jquery.validate',
		modernizr: 'libs/modernizr/modernizr',
		postal: 'libs/postal/postal',
		q: 'libs/q/q',
		goog: 'libs/requirejs-plugins/goog',
		async: 'libs/requirejs-plugins/async',
		swiper: 'libs/swiper/swiper',
		watch: 'libs/watch/watch',
		angular: 'libs/angular/angular',
		angularAnimation: 'libs/angular-animate/angular-animate',
		angularScroll: 'libs/angular-scroll/angular-scroll',
		//angularResource: 'libs/angular/angular-resource',
	    //angularmap: 'libs/angular-google-maps/angular-google-maps.min',
	    postaldiagnostics: 'libs/postal.diagnostics.js/postal.diagnostics',
	    infobox: 'libs/google-maps-utility-library-v3-infobox/infobox',
	    keydragzoom: 'libs/google-maps-utility-library-v3-keydragzoom/keydragzoom',
	    marker: 'libs/google-maps-utility-library-v3-markerwithlabel/markerwithlabel',
	    richmarker: 'libs/js-rich-marker/richmarker',
	    markercluster:'libs/markerclustererplus/markerclusterer',
		gmaploader: 'classes/checkout/googlemaploader',
		productgroupfiltering : 'classes/ProductGroupfilter',
		deprecatedSwiper: 'deprecated/idangerous.swiper-2.6.1.min',
		lodash: 'libs/lodash/lodash',
		toArrayFilter:'libs/angular-toArrayFilter/toArrayFilter',
		tryggehandel :'third-party/tryggehandel',
		fitText: 'classes/fitText',
		//lodash: 'lodash/lodash',
		//gmap371 :'libs/gmap3/gmap3',
	},
	shim: {
		'fancybox': ['jquery'],
		'deprecatedSwiper': ['jquery'],
		'libs/gmap3/gmap3.min': ['jquery'],
		'libs/gmap3/gmap3': ['jquery'],
		'libs/jquery-validation/jquery.validate': ['jquery'],
		'deprecated/idangerous.swiper-2.6.1.min': ['jquery'],
		'libs/jquery-form/jquery.form': ['jquery'],
        modernizr: {
            exports: 'Modernizr'
        },
        angular: {
    		exports: "angular"
		},
		angularAnimation: {
			deps:['angular']
		},
		angularScroll: {
			deps:['angular']
		},
		angularmap: {
			deps:['angular','keydragzoom','infobox','marker','richmarker','lodash','markercluster']
		},
		toArrayFilter:{
			deps:['angular']
		}
    },
    urlArgs: "molover=082018"
});
define("config", function(){});

